import { createFileRoute } from '@tanstack/react-router';
import { lazy } from '@loadable/component';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';

const CreateRolePage = lazy(
    async () => (await import(/* webpackChunkName: "Roles" */ '@mews-commander/roles')).CreateRolePage
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Roles/CreateRole')({
    beforeLoad: ({ context: { checkFeatureFlag, checkPrivilege } }) => {
        checkFeatureFlag(FeatureFlag.newPermissionsEnabled);
        checkPrivilege('admin');
    },
    component: () => <CreateRolePage />,
    staticData: {
        title: TextKey.CreateRole,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
});
